import {Button} from '_core'
import clsx from 'clsx'
import {useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {
  selectEditOrder,
  selectIsAutoDiscountRemoved,
  selectIsValidatingDiscount,
  selectIsWineMackerChoiceDiscountDisabled,
  selectViewOrderType,
  setIsAutoDiscountRemoved,
  setIsDirtyDiscount,
  updateEditOrderTaxAndAutoDiscountRemoved,
  validateDiscountsAndRefetchTax,
} from '../../redux/order/orderEditSlice'
import {Order} from '../../models/EditOrderState'
import {orderTypes} from 'app/constant'

const EnableAutoDiscount = () => {
  const dispatch = useDispatch()
  const isAutoDiscountRemoved = useSelector<RootState, boolean>(selectIsAutoDiscountRemoved)
  const isWineMackerChoiceDiscountDisabled = useSelector<RootState, boolean>(
    selectIsWineMackerChoiceDiscountDisabled
  )
  const order = useSelector<RootState, Order>(selectEditOrder)
  const isValidating = useSelector<RootState, boolean>(selectIsValidatingDiscount)
  const timeoutRef = useRef<any>()
  const orderType = useSelector<RootState, any>(selectViewOrderType)

  const handleToggleAutoDiscount = async () => {
    dispatch(setIsAutoDiscountRemoved(!isAutoDiscountRemoved))
    dispatch(setIsDirtyDiscount(true))
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    const exec = async () => {
      await updateEditOrderTaxAndAutoDiscountRemoved({
        isAutoDiscountRemoved: !isAutoDiscountRemoved,
        id: order.orderEditId,
      })
      await dispatch(validateDiscountsAndRefetchTax())
    }
    const timeoutId = setTimeout(exec, 1000)
    timeoutRef.current = timeoutId
  }

  return (
    <Button
      id='btnTaxCalculation'
      className={clsx(
        'btn btn-link p-0 bg-transparent text-primary-active fw-bolder',
        isAutoDiscountRemoved ? 'me-2' : 'me-0'
      )}
      title={isAutoDiscountRemoved ? 'Enable' : 'Disable'}
      onClick={handleToggleAutoDiscount}
      disabled={
        isValidating || (orderType === orderTypes.WINE_CLUB && isWineMackerChoiceDiscountDisabled)
      }
    />
  )
}

export default EnableAutoDiscount
